<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <section class="about-area grey-bg2 pos-rel pb-50 pt-50">
      <div class="right-shape">
        <img src="assets/img/shape/01.png" alt="" loading="lazy" />
      </div>

      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 col-lg-6 col-md-12">
            <div class="about-img mb-60 pos-rel">
              <div class="about-img__thumb pr-45">
                <img :src="info.image
                  ? info.image.url
                  : '/assets/img/logo/min-logo.png'
                  " loading="lazy" alt="" />
              </div>
              <div class="experience-box heding-bg">
                <h2 class="d-flex" style="align-items: center;">
                  <span>3</span>
                  <span>{{ $t("app.threeYears") }}</span>
                </h2>
                <h4 class="semi-02-title">{{ $t("app.the_charity_work") }}</h4>
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-lg-6 col-md-12">
            <div class="about-wrapper mb-30">
              <div class="section-title text-left mb-20">
                <h6>
                  <span :style="[locale == 'en' ? { left: 'auto' } : {}]"><i class="fas fa-home"></i></span>{{
                    info.title }}
                </h6>
              </div>

              <p v-html="info.body"></p>
              <br />
              <router-link :to="{ name: 'about' }" class="theme_btn theme_btn_bg">
                {{ $t("app.more_to_us") }}
                <span :style="[locale == 'en' ? { left: 'auto' } : {}]">
                  <i :class="locale == 'ar'
                    ? 'fas fa-angle-double-left'
                    : 'fas fa-angle-double-right'
                    "></i>
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "WhoWeAre",
  components: {
    //
  },
  data() {
    return {
      //
      items: [],
      pgLoading: true,
      refs: "about",
      locale: "ar",
      info: "",
      info3: "",
      rows: [],

      magnific_popup: false,
      video_url: "",
    };
  },
  mounted() { },
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }
    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/" + this.refs,
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: 20,
        },
      };
      this.axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
          this.info = res.data.info1;
          this.info3 = res.data.info3;
        })
        .catch(() => {
          //
        })
        .finally(() => { });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
